import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
export class ApiEpSharedPostData {
}
ApiEpSharedPostData.read = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/sharedpostdata/${req.path.id}`,
    method: "GET",
});
//# sourceMappingURL=sharedpostdata.js.map